import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { ShieldCheckIcon, CheckIcon, ZapIcon } from 'lucide-react';
export function OfferBlock() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-60px'
  });
  return <section id="oferta" className="w-full bg-white py-16 md:py-24" ref={ref} data-id="element-170">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-171">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-172">
          {/* Offer card */}
          <div className="relative bg-navy-900 rounded-2xl overflow-hidden" data-id="element-173">
            {/* Gold top border */}
            <div className="h-1.5 bg-gradient-to-r from-gold-700 via-gold-500 to-gold-700" data-id="element-174" />

            <div className="p-8 sm:p-12" data-id="element-175">
              <div className="text-center mb-10" data-id="element-176">
                <span className="inline-block font-body text-gold-500 text-sm font-semibold tracking-widest uppercase mb-4" data-id="element-177">
                  Oferta Completa
                </span>
                <h2 className="font-heading text-3xl sm:text-4xl font-bold text-white mb-4" data-id="element-178">
                  El Protocolo de Aterrizaje:
                  <br data-id="element-179" />
                  <span className="text-gold-500" data-id="element-180">Misión USA 30 Días</span>
                </h2>
                <p className="font-body text-navy-200 max-w-lg mx-auto" data-id="element-181">
                  Todo lo que necesitas para aterrizar con orden, proteger tus
                  ahorros y establecer a tu familia en tiempo récord.
                </p>
              </div>

              {/* Included items */}
              <div className="space-y-3 mb-10" data-id="element-182">
                <div className="flex items-center gap-3" data-id="element-183">
                  <CheckIcon className="w-5 h-5 text-gold-500 flex-shrink-0" aria-hidden="true" data-id="element-184" />
                  <span className="font-body text-white" data-id="element-185">
                    Protocolo de las 72 Horas
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-186">
                  <CheckIcon className="w-5 h-5 text-gold-500 flex-shrink-0" aria-hidden="true" data-id="element-187" />
                  <span className="font-body text-white" data-id="element-188">
                    E-Book: Misión USA 30 Días
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-189">
                  <CheckIcon className="w-5 h-5 text-gold-500 flex-shrink-0" aria-hidden="true" data-id="element-190" />
                  <span className="font-body text-white" data-id="element-191">
                    Checklist Interactivo de Trámites
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-192">
                  <CheckIcon className="w-5 h-5 text-gold-500 flex-shrink-0" aria-hidden="true" data-id="element-193" />
                  <span className="font-body text-white" data-id="element-194">
                    Guía de Vivienda "Sin Crédito"
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-195">
                  <CheckIcon className="w-5 h-5 text-gold-500 flex-shrink-0" aria-hidden="true" data-id="element-196" />
                  <span className="font-body text-white" data-id="element-197">
                    Calculadora de "Burn Rate" Inicial
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-198">
                  <CheckIcon className="w-5 h-5 text-gold-500 flex-shrink-0" aria-hidden="true" data-id="element-199" />
                  <span className="font-body text-white" data-id="element-200">
                    Actualizaciones futuras incluidas
                  </span>
                </div>
              </div>

              {/* Price */}
              <div id="oferta-precio" className="text-center mb-8" data-id="element-201">
                <div className="flex items-center justify-center gap-3 mb-2" data-id="element-202">
                  <span className="font-body text-navy-300 line-through text-lg" data-id="element-203">
                    $97 USD
                  </span>
                  <span className="inline-block bg-gold-500/20 text-gold-400 font-body text-sm font-semibold px-3 py-1 rounded-full" data-id="element-204">
                    -52%
                  </span>
                </div>
                <div className="flex items-baseline justify-center gap-1" data-id="element-205">
                  <span className="font-heading text-6xl sm:text-7xl font-bold text-gold-500" data-id="element-206">
                    $47
                  </span>
                  <span className="font-body text-navy-200 text-lg" data-id="element-207">USD</span>
                </div>
                <p className="font-body text-navy-300 text-sm mt-2" data-id="element-208">
                  Pago único · Sin suscripciones
                </p>
              </div>

              {/* CTA */}
              <div className="text-center" data-id="element-209">
                <a href="https://upwisehub.com/cart/47681705705684:1" target="_blank" rel="noopener noreferrer" onClick={() => {
                // Fire AddToCart via fbq
                if (typeof window.fbq === 'function') {
                  window.fbq('track', 'AddToCart', {
                    content_name: 'Protocolo de Aterrizaje - Misión USA 30 Días',
                    content_type: 'product',
                    value: 47.0,
                    currency: 'USD'
                  });
                }
                // Fallback: fire via image pixel directly
                const img = new Image();
                img.src = 'https://www.facebook.com/tr?id=908936798438947&ev=AddToCart&cd[content_name]=Protocolo+de+Aterrizaje&cd[content_type]=product&cd[value]=47.00&cd[currency]=USD&noscript=1';
              }} className="inline-flex items-center justify-center gap-2 w-full sm:w-auto px-10 py-5 bg-gold-500 text-navy-900 font-body font-bold text-lg rounded-xl hover:bg-gold-400 transition-all duration-200 shadow-lg shadow-gold-500/25 hover:shadow-gold-500/40 hover:scale-[1.02]" data-id="element-210">
                  <ZapIcon className="w-5 h-5" aria-hidden="true" data-id="element-211" />
                  Descargar el Protocolo Ahora
                </a>
                <p className="font-body text-navy-300 text-sm mt-4 flex items-center justify-center gap-2" data-id="element-212">
                  <ShieldCheckIcon className="w-4 h-4 text-gold-500" aria-hidden="true" data-id="element-213" />
                  Acceso inmediato y seguro. Protege tu transición familiar hoy
                  mismo.
                </p>
              </div>
            </div>
          </div>

          {/* Bottom note */}
          <p className="font-body text-gray-500 text-center text-sm mt-6" data-id="element-214">
            Es una fracción de lo que podrías perder en un solo día de errores
            logísticos en Estados Unidos.
          </p>
        </motion.div>
      </div>
    </section>;
}